import { engineFetchJson } from '@/lib/engineHttp';

export interface NotebookSummary {
  id: string;
  title: string;
  owner?: string | null;
  created?: string | null;
  source_count?: number | null;
}

export interface NotebookListResponse {
  notebooks: NotebookSummary[];
  total: number;
  authenticated: boolean;
}

export interface NotebookAuthStatus {
  authenticated: boolean;
  message: string;
}

export interface NotebookQueryResponse {
  answer: string;
  conversation_id?: string | null;
  sources_used?: unknown[];
  citations?: Record<string, unknown>;
  turn_number?: number;
}

export const notebooklmApi = {
  authStatus: (): Promise<NotebookAuthStatus> => engineFetchJson('/flash/auth-status'),
  listNotebooks: (): Promise<NotebookListResponse> => engineFetchJson('/flash/notebooks'),
  query: (notebookId: string, question: string): Promise<NotebookQueryResponse> =>
    engineFetchJson('/flash/query', {
      method: 'POST',
      body: JSON.stringify({ notebook_id: notebookId, question }),
    }),
};

export const CURRENT_NOTEBOOK_ALIASES = [
  'memos-active',
  'strategy-active',
  'memos1',
  'strategy2',
  'ops-active',
  'ops5',
  'arch',
  'arch2',
  'ref',
  'ip',
  'sotu',
];
